import ace from 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-monokai';

const initAll = () => {
  document.querySelectorAll('textarea.ace-editor').forEach((textarea) => {
    const editorDiv = document.createElement('div');
    editorDiv.style.width = `${textarea.clientWidth}px`;
    editorDiv.style.height = `${textarea.clientHeight}px`;
    textarea.parentNode.insertBefore(editorDiv, textarea.nextSibling);
    editorDiv.innerHTML = textarea.value;
    textarea.style.display = 'none';

    const editor = ace.edit(editorDiv);
    editor.session.setMode('ace/mode/json');
    editor.setTheme('ace/theme/monokai');
    editor.session.on('change', () => {
      textarea.value = editor.getValue();
    });

    // Enable line wrapping
    editor.session.setOption('wrap', true);

    // Add command to move line up
    editor.commands.addCommand({
      name: 'moveLineUp',
      bindKey: { win: 'Ctrl-Up', mac: 'Command-Shift-Up' },
      exec: (editor) => {
        editor.moveLinesUp();
      }
    });

    // Add command to move line down
    editor.commands.addCommand({
      name: 'moveLineDown',
      bindKey: { win: 'Ctrl-Down', mac: 'Command-Shift-Down' },
      exec: (editor) => {
        editor.moveLinesDown();
      }
    });
  });
};

const start = () => {
  document.addEventListener('page:load', initAll);
  document.addEventListener('ajax:success', initAll);
};

export default { initAll, start };
